import React from 'react';
import Button from 'Components/DesignSystem/Button/Button';

/**
 * The shared show-the-rest control for sliced lists — 11 call sites across
 * Products, Attribute and Category. On DS `Button` (subtle) since 2026-09-01:
 * the legacy render was bootstrap `btn text-primary` with a hand-rolled
 * `<u>` — link-blue ink that could not theme, an underline pretending to be a
 * link, and bootstrap's focus halo instead of the DS focus-visible ring.
 *
 * The API is unchanged (`condition` gates rendering entirely; `state` flips the
 * label between "view more"/"view less"; `handleClick` toggles; `data-testid`
 * forwards), so no call site changed.
 */
export default function ViewMoreButton(props) {
  const { condition, handleClick, state, 'data-testid': dataTestId } = props;

  if (!condition) return <></>;

  return (
    <Button
      variant="subtle"
      size="sm"
      className="tw-my-2"
      aria-expanded={!!state}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      view {state ? 'less' : 'more'}
    </Button>
  );
}
